import { RelaisMainInfoFragment } from '../../graphql/generated/graphql';
import { ClientFormState } from '../../types/client/client.def';

export const ADD_CLIENT = 'ADD_CLIENT';
export const CLEAR_CLIENT = 'CLEAR_CLIENT';
export const UPDATE_RELAIS = 'UPDATE_RELAIS';
export const COPY_DELIVERY_INFORMATIONS = 'COPY_DELIVERY_INFORMATIONS';

export type ClientPayload = ClientFormState;

export interface AddClientActions {
  type: typeof ADD_CLIENT;
  payload: ClientFormState;
}
export const addClient = (payload: ClientPayload): AddClientActions => ({
  type: ADD_CLIENT,
  payload
});

export interface CopyDeliveryInformationsActions {
  type: typeof COPY_DELIVERY_INFORMATIONS;
}

export const copyDeliveryInformations = (): CopyDeliveryInformationsActions => ({
  type: COPY_DELIVERY_INFORMATIONS
});

export interface UpdatePointRelaisActions {
  type: typeof UPDATE_RELAIS;
  payload: RelaisMainInfoFragment;
}
export const updatePointRelais = (
  payload: RelaisMainInfoFragment
): UpdatePointRelaisActions => ({
  type: UPDATE_RELAIS,
  payload
});

export interface ClearClientActions {
  type: typeof CLEAR_CLIENT;
}
export const clearClient: ClearClientActions = { type: CLEAR_CLIENT };

export type ClientActions =
  | AddClientActions
  | ClearClientActions
  | UpdatePointRelaisActions
  | CopyDeliveryInformationsActions;
